
export default [
  {
    path: '/admin/motor-withdraws',
    name: 'motor-withdraws',
    meta: { requiresAuth: true },
    component: () => import('@/pages/credit-operation/motor-withdraw')
  }
]
